import React from "react";

const STATUS_STYLES = {
  open: { bg: "#EFF6FF", color: "#1D4ED8", dot: "#3B82F6" },
  in_progress: { bg: "#FFF7ED", color: "#C2410C", dot: "#F97316" },
  resolved: { bg: "#F0FDF4", color: "#15803D", dot: "#22C55E" },
  closed: { bg: "#F9FAFB", color: "#6B7280", dot: "#9CA3AF" },
  deleted: { bg: "#FEF2F2", color: "#991B1B", dot: "#EF4444" },
  active: { bg: "#F0FDF4", color: "#15803D", dot: "#22C55E" },
  inactive: { bg: "#FEF2F2", color: "#DC2626", dot: "#EF4444" },
  degraded: { bg: "#FFF7ED", color: "#C2410C", dot: "#F97316" },
  down: { bg: "#FEF2F2", color: "#991B1B", dot: "#DC2626" },
  healthy: { bg: "#F0FDF4", color: "#15803D", dot: "#22C55E" },
  warning: { bg: "#FFF7ED", color: "#C2410C", dot: "#F59E0B" },
  critical: { bg: "#FEF2F2", color: "#DC2626", dot: "#EF4444" },
  unknown: { bg: "#F9FAFB", color: "#6B7280", dot: "#9CA3AF" },
  running: { bg: "#F0FDF4", color: "#15803D", dot: "#22C55E" },
  stopped: { bg: "#FEF2F2", color: "#DC2626", dot: "#EF4444" },
};

const PRIORITY_STYLES = {
  critical: { bg: "#FEF2F2", color: "#DC2626", border: "#FECACA" },
  high: { bg: "#FFF7ED", color: "#EA580C", border: "#FED7AA" },
  medium: { bg: "#FEFCE8", color: "#CA8A04", border: "#FEF08A" },
  low: { bg: "#F0FDF4", color: "#16A34A", border: "#BBF7D0" },
};

export function StatusBadge({ status }) {
  const s = STATUS_STYLES[status?.toLowerCase()] || STATUS_STYLES.unknown;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        padding: "3px 9px",
        borderRadius: 20,
        background: s.bg,
        color: s.color,
        fontSize: 11,
        fontWeight: 600,
        whiteSpace: "nowrap",
      }}
    >
      <span
        style={{
          width: 5,
          height: 5,
          borderRadius: "50%",
          background: s.dot,
          flexShrink: 0,
        }}
      />
      {status?.replace(/_/g, " ")}
    </span>
  );
}

export function PriorityBadge({ priority }) {
  const p = PRIORITY_STYLES[priority?.toLowerCase()] || PRIORITY_STYLES.medium;
  return (
    <span
      style={{
        padding: "3px 9px",
        borderRadius: 20,
        background: p.bg,
        color: p.color,
        fontSize: 11,
        fontWeight: 600,
        border: `1px solid ${p.border}`,
        whiteSpace: "nowrap",
      }}
    >
      {priority}
    </span>
  );
}
